import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'

export default function BasicLineChart({
  compStyle = { height: '400px', width: '100%' },
  xAxisData = [],
  seriesData = [],
  barColor = '#5470c6',
  yAxisName = '',
  xAxisName = '',
  xNameLocation = '', //'start' 'middle' 'end' วางชื่อตรงกลางของแกน
  xNameGap = 0, // ระยะห่างจากแกน (เพิ่มค่าเพื่อให้ห่างมากขึ้น)
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    xAxis: {
      type: 'category',
      data: xAxisData,
      name: xAxisName,
      nameLocation: xNameLocation, // วางชื่อตรงกลางของแกน
      nameGap: xNameGap, // ระยะห่างจากแกน (เพิ่มค่าเพื่อให้ห่างมากขึ้น)
      // nameTextStyle: {
      //   padding: [10, 0, 0, 0], // [บน, ขวา, ล่าง, ซ้าย]
      // },
    },
    yAxis: {
      type: 'value',
      name: yAxisName,
    },
    series: [
      {
        data: seriesData,
        type: 'line',
        itemStyle: {
          color: barColor, // สีน้ำเงิน
        },
      },
    ],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%', // เพิ่มพื้นที่ด้านล่าง
      top: '4%',
      containLabel: true,
    },
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
